import React, {ReactElement} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/pro-regular-svg-icons";
import Button, {ButtonProps} from "../button";

interface LoadingButtonProps extends Omit<ButtonProps, 'children'> {
    isLoading: boolean;
    body: string | React.ReactNode;
    loadingBody?: string | React.ReactNode;
}

const LoadingButton = ({body, loadingBody, variant = 'primary', size = 'sm', isLoading = false, type = 'button', className, ...props }: LoadingButtonProps): ReactElement => (
        <Button
            className={className}
            variant={isLoading ? 'ghost' : variant}
            size={size}
            disabled={isLoading || props.disabled}
            type={type}
            {...props}
        >
            {isLoading ? (
                <div className='flex flex-row gap-x-1 items-center'>
                    <FontAwesomeIcon icon={faSpinner} spin />
                    {loadingBody}
                </div> ) : ( 
                    body
                )
            }
        </Button>
    )
export default LoadingButton;